export default __webpack_public_path__ + "static/media/id_globe_simple.67cc6fd7.svg";